<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {
      basic_url: Config.dev_url,
    }
  },
  methods: {
    selReportnum(item, selData) {
      this.$store.state.detailInfo.UDWOTYPE = '缺陷工单';
    },
    clearReportnum(item, data) {
      this.$store.state.detailInfo[item.model] = '';
      this.$store.state.detailInfo.reportnumdesc = '';
      this.$store.state.detailInfo.UDWOTYPE = '';
    },
    seFixplan(item, selData) {
      this.$store.state.detailInfo.UDWOTYPE = '维修工单';
    },
    clearFixplan(item, data) {
      this.$store.state.detailInfo[item.model] = '';
      this.$store.state.detailInfo.fixplandesc = '';
      this.$store.state.detailInfo.UDWOTYPE = '';
    },
    chooseLocation(item, selData) {
      var url = this.basic_url + "/api-apps/app/locationmanagementApp";
      var data = {
        location: selData.assetlocation,
      }
      this.$axios.get(url, { params: data }).then((res) => {
        if (res.data.code == 0) {
          this.$set(this.$store.state.detailInfo, 'location_DESCRIPTION', res.data.data[0].description)
        }
      }).catch((wrong) => {
      })
    },
  }
}
</script>